/* eslint-disable react/self-closing-comp */
/* eslint max-len: 0*/

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

const Logo = ({ isFetching, mhub, customLogoSrc }) => (
  <Link to="/" className={customLogoSrc === '' && `logo ${isFetching ? 'loading' : ''}`}>
    {customLogoSrc === '' ?
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 204 44"
        enableBackground="new 0 0 204 44"
      >
        <g>
          <polygon className="brick-1" fill="#0094B3" points="22.1,22.7 1,43.8 1,22.7"></polygon>
          <polygon className="brick-8" fill="#28A181" points="23.7,22.7 44.8,43.8 44.8,22.7"></polygon>
          <polygon className="brick-7" fill="#28A181" points="67.5,22.7 46.3,43.8 46.3,22.7"></polygon>
          <polygon className="brick-5" fill="#358337" points="69,22.7 90.1,43.8 90.1,22.7"></polygon>
          <polygon className="brick-2" fill="#0094B3" points="22.1,0 1,21.1 22.1,21.1"></polygon>
          <polygon className="brick-4" fill="#8AC193" points="67.5,0 46.3,21.1 67.5,21.1"></polygon>
          <polygon className="brick-3" fill="#8AC193" points="23.7,0 44.8,21.1 23.7,21.1"></polygon>
          <polygon className="brick-6" fill="#358337" points="69,0 90.1,21.1 69,21.1"></polygon>
        </g>
        {
          mhub ?
            <g >
              <path fill="#272727" d="M117.9,33.3V23l-3,5.3h-3.4l-3-5.3v10.3h-5.3V11.8h5.2l4.8,9.5l4.8-9.5h5.2v21.5H117.9z"></path>
              <path fill="#555555" d="M144.8,33.3v-8.5h-5.6v8.5h-5.3V11.8h5.3v8.3h5.6v-8.3h5.3v21.5H144.8z"></path>
              <path fill="#555555" d="M168.5,33.5c-4.5,0-8.1-3-8.1-7.7v-14h5.3v13.8c0,2,1.1,3.1,2.8,3.1s2.9-1.1,2.9-3.1V11.8h5.3v13.9C176.6,30.5,172.9,33.5,168.5,33.5z"></path>
              <path fill="#555555" d="M196.3,33.3H187V11.8h8.9c4.5,0,6.8,2.5,6.8,6.2c0,2.4-1.7,3.8-2.4,4.3c0.9,0.5,2.7,1.7,2.7,4.7C203,31.1,200.1,33.3,196.3,33.3z M195.5,16.6h-3.3v3.5h3.3c1.4,0,1.9-0.9,1.9-1.7S197,16.6,195.5,16.6z M195.8,24.8h-3.6v3.8h3.6c1.4,0,1.9-1,1.9-1.9S197.2,24.8,195.8,24.8z"></path>
            </g>
            : null
        }
      </svg>
      :
      <img className="logo_custom_wl" alt="Logo" src={customLogoSrc} />
    }
  </Link>
);

Logo.propTypes = {
  isFetching: PropTypes.bool,
  mhub: PropTypes.bool,
  customLogoSrc: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  ...state.fetchM,
});

export default connect(mapStateToProps)(Logo);



// WEBPACK FOOTER //
// ./src/components/NewLogo.jsx